import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import { Box } from '@material-ui/core';
import moment from 'moment';

import { Conditional } from 'common/components/layout';
import { Button, BUTTON } from 'components/common/Button/Button';
import { FormSection, DataList, FormDialog } from 'forms/components/common';
import AuditHistory from 'pages/delegationOfAuthority/v2/containers/DelegationSidePanel/AuditHistory/AuditHistory';

const DATE_FORMAT = 'DD MMM YYYY';

function DOADetails(props) {
    const { signatureRequest, taskBox } = props;
    const { binderName, delegation } = signatureRequest;
    const [showDialog, toggleDialog] = useState(false);

    const sentDate = lodash.get(signatureRequest, 'sentDate', null);
    const startDate = lodash.get(delegation, 'startDate', null);
    const endDate = lodash.get(delegation, 'endDate');

    return (
        <Fragment data-cy="DOADetails">
            <FormSection headerText="Binder">{binderName}</FormSection>
            <FormSection headerText="From">{lodash.get(signatureRequest, 'createdBy.displayName')}</FormSection>
            <FormSection headerText="Sent Date">
                <span>{moment.utc(sentDate).utcOffset(props.timezone).format(DATE_FORMAT)}</span>
            </FormSection>
            <FormSection headerText="User">{lodash.get(delegation, 'user.displayName', '')}</FormSection>
            <FormSection headerText="Role">{lodash.get(delegation, 'rolesManagement.name', '')}</FormSection>
            <FormSection headerText="Tasks">
                <DataList source={lodash.get(delegation, 'tasks', [])} getter={({ taskName }) => taskName} />
            </FormSection>
            <FormSection headerText="Start Date">
                <span>{moment.utc(startDate).format(DATE_FORMAT)}</span>
            </FormSection>
            <FormSection headerText="End Date" hidden={lodash.isNil(endDate)}>
                <span>{moment.utc(endDate).format(DATE_FORMAT)}</span>
            </FormSection>
            <FormSection headerText="DOA Testament" hidden={taskBox !== 'inbox'}>
                {lodash.get(signatureRequest, 'statement')}
            </FormSection>
            <Box>
                <Conditional condition={taskBox === 'inbox'}>
                    <Button
                        bgcolor={BUTTON.BGCOLOR.CLEAR}
                        color={BUTTON.COLOR.BLACK}
                        outline={BUTTON.OUTCOLOR.LIGHTGREY}
                        onClick={() => toggleDialog(true)}
                        data-cy="DOADetails-Button"
                    >
                        Show History
                    </Button>
                </Conditional>
            </Box>
            <FormDialog
                open={showDialog}
                title={`History for ${lodash.get(delegation, 'user.displayName', '')}`}
                onClose={() => toggleDialog(false)}
                data-cy="DOADetails-onClose"
            >
                <AuditHistory
                    binderId={lodash.get(delegation, 'binderId')}
                    delegationId={lodash.get(delegation, 'id')}
                    delegationName={lodash.get(delegation, 'user.displayName', '')}
                />
            </FormDialog>
        </Fragment>
    );
}

export default connect((state, props) => {
    const institutionTimezone = props.timezone || lodash.get(state, 'me.institutionTimezone', 'Z');

    return {
        timezone: institutionTimezone,
    };
})(DOADetails);
